import PriceToPayHeader from './parts/Header'
import PriceItemsList from './parts/PriceItemsList'
import { priceToPayStyles } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/styles'
import { PriceToPayBaseProps } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/types'
import { FC, memo } from 'react'
import { View } from 'react-native'

const PriceToPayStatic: FC<PriceToPayBaseProps> = ({
    price,
    items = [],
    headingVariant = 'h4',
}) => {
    return (
        <View style={priceToPayStyles.container}>
            <View style={priceToPayStyles.itemsContainer}>
                <PriceItemsList items={items} />
            </View>
            <View style={priceToPayStyles.headerContainer}>
                <PriceToPayHeader price={price} headingVariant={headingVariant} />
            </View>
            <View style={priceToPayStyles.divider} />
        </View>
    )
}

export default memo(PriceToPayStatic)
